import { render, staticRenderFns } from "./editNm.vue?vue&type=template&id=34d9132a&"
import script from "./editNm.vue?vue&type=script&lang=js&"
export * from "./editNm.vue?vue&type=script&lang=js&"
import style0 from "./editNm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports